import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import AuthorStyles from './author-styles'
import ApiContext from '../utils/api-context'
import { useTranslation } from 'next-i18next'

const Author = (props) => {
  const { author } = props
  const { t, i18n } = useTranslation()
  const classes = AuthorStyles({})
  const { apiUrl, cdnUrl } = useContext(ApiContext)

  return (
    <div className={classes.root}>
      <div className={classes.profileImage}>
        <img
          src={`${author.profileImage.url}`}
          alt={`${author.firstname} ${author.lastname}`}
        />
      </div>
      <div>
        <h6 className={classes.writtenBy}>
          Written By {author.firstname} {author.lastname}
        </h6>
        <p className={classes.profileLink}>
          <Link
            href={`/authors/${author.username}`}
            as={`/authors/${author.username}`}
          >
            View Profile
          </Link>
        </p>
      </div>
    </div>
  )
}
Author.propTypes = {
  author: PropTypes.any.isRequired,
}
export default Author
